import React from "react";
import * as actions from '../Actions';
import Service from '../../service/Service';
const service = new Service();

export default function ShareOptions({ discussion, eleRef }) {
    return (
        <div className="sharing-options">
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareArticle(discussion.discussionId, 'facebook', global.redirect_url + 'discussions/t/' + service.replaceSymbols(actions.only_title(discussion.title) + '-' + (discussion.discussionId)))}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../../assets/images/facebook.png')} className="loadingImg facebookimg" alt="" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareArticle(discussion.discussionId, 'twitter', global.redirect_url + 'discussions/t/' + service.replaceSymbols(actions.only_title(discussion.title) + '-' + (discussion.discussionId)))}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../../assets/images/twitter.png')} className="loadingImg twitterimg" alt="" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareArticle(discussion.discussionId, 'pintrest', global.redirect_url + 'discussions/t/' + service.replaceSymbols(actions.only_title(discussion.title) + '-' + (discussion.discussionId)))}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../../assets/images/pintrest.png')} className="loadingImg pintrestimg" alt="" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareArticle(discussion.discussionId, 'whatsapp', global.redirect_url + 'discussions/t/' + service.replaceSymbols(actions.only_title(discussion.title) + '-' + (discussion.discussionId)))}>
                    <div className="M16_61 social-share">
                        <img src="https://cdn.cdnparenting.com/articles/babynameimages/loader.gif" data-src={require('../../assets/images/whatsapp.png')} className="loadingImg whatsappimg" alt="" />
                    </div>
                </li>
            </ul>
        </div>
    );
}


// WEBPACK FOOTER //
// src/shared/discussions/common/ShareOptions.js